import React, { useState } from 'react';
import './Transfer.css';
import { API_URL } from '../config';
import TransferForm from './TransferForm';

// The very first thing rendered at #transfer/<branchcode> -- nothing about
// the branch (not even its name) is revealed until the code is verified.
// Wrong code, a disabled form, and an unknown branch code all look
// identical from here, by design.
const TransferAccessGate = ({ branchCode }) => {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [verified, setVerified] = useState(null); // { branchName, introText, reviewText, matchFoundText, successText, alreadySubmittedText, grades }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/transfer/verify-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ branch: branchCode, code: code.trim() }),
      });
      const data = await res.json();
      if (data.valid) {
        setVerified({
          branchName: data.branch_name,
          introText: data.intro_text,
          reviewText: data.review_text,
          matchFoundText: data.match_found_text,
          successText: data.success_text,
          alreadySubmittedText: data.already_submitted_text,
          grades: data.grades || [],
        });
      } else {
        setError(data.error || 'Invalid code');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (verified) {
    return (
      <TransferForm
        branchCode={branchCode}
        code={code.trim()}
        branchName={verified.branchName}
        introText={verified.introText}
        reviewText={verified.reviewText}
        matchFoundText={verified.matchFoundText}
        successText={verified.successText}
        alreadySubmittedText={verified.alreadySubmittedText}
        grades={verified.grades}
      />
    );
  }

  return (
    <div className="transfer-container">
      <h1 className="transfer-title">Transfer Request</h1>
      <p className="transfer-subtitle">Enter the access code you were given to continue.</p>
      {error && <div className="transfer-error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="transfer-field">
          <label htmlFor="transfer-access-code">Access Code</label>
          <input
            id="transfer-access-code"
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            autoFocus
          />
        </div>
        <button type="submit" className="transfer-btn" disabled={submitting || !code.trim()}>
          {submitting ? 'Checking…' : 'Continue'}
        </button>
      </form>
    </div>
  );
};

export default TransferAccessGate;
